export interface NavItem {
  label: string;
  icon?: string;
  link?: string;
  isRoot?: boolean;
}
